export default "__VITE_ASSET__CTmfZtEY__"